var modalButtons = document.querySelectorAll('.modal__topics');
var modalBoxs = document.querySelectorAll('.news-modal__box');

var modalButton;

var modalOpen = function(e){
  modalButton = e.currentTarget;
  var target = '.' + modalButton.getAttribute("id");

  if($('body').hasClass('page-index')){
    $.fn.fullpage.setResponsive(true);
    $('body').css({
      'overflow': 'hidden'
    });
  }
  var _win_h = $(window).height();
  if (!$('body').hasClass('modal-open')) {
    $('body').addClass('modal-open');
    $('#wrapper').css({
      'overflow':'hidden',
    });
    $(target).css({
      'visibility': 'visible',
      'height': (_win_h * 0.75),
      'position':'fixed'
    })
  }
}

function closeModal(){
  if($('body').hasClass('page-index')){
    $.fn.fullpage.setResponsive(false);
    $('body').css({
      'overflow': ''
    });
  }
  $('body').removeClass('modal-open');
  $('#wrapper').css({
    'width':'',
    'top': '',
    'overflow': ''
  });
  $('.news-modal__box').css({
    'height': '',
    'visibility': 'hidden'
  });
};


for(var i = 0; i < modalButtons.length; i++){
  modalButtons[i].addEventListener('click',function(e){
    var modal_scroll = $(window).scrollTop();
    modalOpen(e);

    $('.btn_close').on('click', function(){
      closeModal();
      $('html, body').scrollTop(modal_scroll);
    });

    $('.modal__background').on('click', function(){
      closeModal();
      $('html, body').scrollTop(modal_scroll);
    })
  });
}

